import { observer } from 'mobx-react';
import { Navigate, Outlet } from 'react-router-dom';
import { useStore } from 'hooks/useStore';

interface PublicFlaggedRouteProps {
  flagKey: string;
  redirectTo?: string;
}

const PublicFlaggedRoute = observer(({ flagKey, redirectTo = '/' }: PublicFlaggedRouteProps) => {
  const { FeatureFlagStore } = useStore();

  if (!FeatureFlagStore.isPublicLoaded) {
    return null;
  }

  if (!FeatureFlagStore.isPublicEnabled(flagKey)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
});

export default PublicFlaggedRoute;
